import {notification} from "@atg-global-shared/notification";

export const DEFAULT_CHAT_NOTIFICATIONS_OPTIONS = {
    icon: false,
    position: notification.POSITION.BOTTOM_RIGHT,
    autoClose: 4000,
    hideProgressBar: true,
    newestOnTop: false,
    closeOnClick: true,
    closeButton: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
};
